import React from "react";
import blood from "../../../assests/images/blood.svg";
import tissue from "../../../assests/images/tissue.svg";
import useResponsiveFlags from "../../../hooks/useResponsiveFlags";

export default function Table(props) {
  const { isMobile } =
    useResponsiveFlags();
  // const desktopScreen = props.loggedin ? isDesktopLogin : isDesktop;
  // const tabletScreen = props.loggedin ? isTabletLogin : isTablet;
  const tableData = [
    { parent: "B cells", cells: ["B cells naive", "B cells memory"] },
    { parent: "Plasma cells", cells: ["Plasma cells"] },
    { parent: "CD8 T cells", cells: ["T cells CD8"] },
    {
      parent: "CD4 T cells",
      cells: [
        "T cells CD4 naive",
        "T cells CD4 memory resting",
        "T cells CD4 memory activated",
        "T cells follicular helper",
        "T cells regulatory (Tregs)",
      ],
    },
    { parent: "CD8 T cells", cells: ["T cells gamma delta"] },
    { parent: "NK cells", cells: ["NK cells resting", "NK cells activated"] },
    {
      parent: "Monocytes and Macrophages",
      cells: [
        "Monocytes",
        "Macrophages M0",
        "Macrophages M1",
        "Macrophages M2",
      ],
    },
    {
      parent: "Dendritic cells",
      cells: ["Dendritic cells resting", "Dendritic cells activated"],
    },
    {
      parent: "Mast cells",
      cells: ["Mast cells resting", "Mast cells activated"],
    },
    { parent: "Eosinophils", cells: ["Eosinophils"] },
    { parent: "Neutrophils", cells: ["Neutrophils"] },
  ];

  const tissueOnlyCells = [
    "Fibroblasts",
    "Endothelial cells",
    "Epithelial cells",
  ];

  const rows = [];

  tableData.forEach((group, groupIdx) => {
    group.cells.forEach((cell, cellIdx) => {
      rows.push({
        key: `g${groupIdx}-c${cellIdx}`,
        parent: cellIdx === 0 ? group.parent : null,
        parentSpan: cellIdx === 0 ? group.cells.length : 0,
        cell,
      });
    });
  });

  const bloodRowCount = rows.length;

  tissueOnlyCells.forEach((cell, idx) => {
    rows.push({
      key: `tissue-${idx}`,
      parent: idx === 0 ? "" : null,
      parentSpan: idx === 0 ? tissueOnlyCells.length : 0,
      cell,
    });
  });

  const totalRows = rows.length;
  const tissueOnlyCount = totalRows - bloodRowCount;

  return (
    <>
      <div className="app-container">
        <p className="home-card-title">
          Cell Type List for Blood and Tissue Mode
        </p>
        <div className="fractions-table-div">
          <table className="cell-type-table" >
            <thead>
              <tr>
                {!isMobile && <th className="col-parent">Parent Subsets</th>}
                <th className="col-cell">Cell Type</th>
                <th className="col-spacer"></th>
                <th className="col-bar-header">
                  <img
                    src={blood}
                    alt="blood"
                  />
                </th>
                <th className="col-spacer"></th>
                <th className="col-bar-header">
                  <img
                    src={tissue}
                    alt="tissue"
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr
                  key={row.key}
                  className={idx >= bloodRowCount ? "tissue-only-row" : ""}
                >
                  {!isMobile && row.parentSpan > 0 && (
                    <td
                      className={
                        idx >= bloodRowCount
                          ? "parent-cell empty-parent"
                          : "parent-cell"
                      }
                      rowSpan={row.parentSpan}
                    >
                      {row.parent}
                    </td>
                  )}
                  <td className="cell-type-cell">{row.cell}</td>

                  {idx === 0 && (
                    <>
                      <td className="spacer-cell" rowSpan={bloodRowCount}></td>
                      <td className="blood-mode-cell" rowSpan={bloodRowCount}>
                        <div className="vertical-hr-wrapper">
                          <div className="vertical-hr">Blood Mode</div>
                        </div>
                      </td>
                      <td className="spacer-cell" rowSpan={totalRows} ></td>
                      <td className="tissue-mode-cell" rowSpan={totalRows}>
                        <div className="vertical-hr-wrapper">
                          <div className="vertical-hr" style={{ paddingTop: "110px" }}>Tissue Mode</div>
                        </div>
                      </td>
                    </>
                  )}

                  {idx === bloodRowCount && (
                    <>
                      <td
                        className="spacer-cell"
                        rowSpan={tissueOnlyCount}
                      ></td>
                      <td
                        className="spacer-cell"
                        rowSpan={tissueOnlyCount}
                      ></td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
